import React from "react";
import PropTypes from "prop-types";

class Filter extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.props.handleClick(this.props.value);
  }

  render() {
    return (
      <label
        className={
          this.props.isSelected
            ? "badge filter-selected"
            : "badge filter-default"
        }
        onClick={this.handleClick}
      >
        {this.props.value}
      </label>
    );
  }
}

Filter.propTypes = {
  handleClick: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired
};

export default Filter;



// WEBPACK FOOTER //
// ./src/common/Filter.js